import { render } from "./ShortResponse.vue?vue&type=template&id=31073116"
import script from "./ShortResponse.vue?vue&type=script&lang=js"
export * from "./ShortResponse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__